// extracted by mini-css-extract-plugin
module.exports = {"navbarItem":"navbar-module--navbarItem--39mEO","activeNavbar":"navbar-module--activeNavbar--3b1Ej"};